<template>
    <div class="container my-2">
        <div id="debug-info" style="position: fixed; z-index: 9999; top: 80px; right: 10px;" v-if="1 == 0">
            Logado AD: {{ this.$store.getters.userInfo.origem === "AD" }} <br>
        </div>
        
        <div style="text-align: center">
            <loading :active.sync="carregando" :is-full-page="true"></loading>
        </div>
        
        <mensagemAlerta :mensagens="mensagemSucesso" />
        <mensagemAlerta :mensagens="mensagemErro" />
        
        <div class="mt-3 mb-3">
        <span
                class="title h4"
                v-b-tooltip.hover="{ variant: 'primary', placement: 'right' }"
                title="Restrição de visualização do lançamento por usuários não vinculados"
              >
                Incluir Nova Restrição
                <b-icon
                  variant="primary"
                  icon="info-circle-fill"
                  class="ml-2"
                />
            </span>
        </div>

        <b-card>
            <form @submit.prevent="incluirRestricao">
                <b-row class="mb-3">
                    <b-col sm="3">
                        <label for="codigoTributo">Código do Tributo <span class="text-danger">*</span></label>
                        <b-form-input 
                            id="codigoTributo" 
                            list="lista-tributos" 
                            v-model="novoFormulario.codigoTributo" 
                            placeholder="Digite ou escolha o código"
                            required>
                        </b-form-input>
                        <datalist id="lista-tributos">
                            <option v-for="tributo in tributos" :key="tributo.ID_TRIBUTO" :value="tributo.CODIGO">
                                {{ tributo.DESCRICAO }}
                            </option>
                        </datalist>
                    </b-col>
                    
                    <b-col sm="4">
                        <label for="orgaoCobranca">Órgão de Cobrança <span class="text-danger">*</span></label>
                        <b-form-select 
                            id="orgaoCobranca" 
                            v-model="novoFormulario.idOrgaoCobranca" 
                            required>
                            <b-form-select-option value="" disabled>Selecione um Órgão</b-form-select-option>
                            <b-form-select-option 
                                v-for="orgao in orgaosCobranca" 
                                :key="orgao.ID" 
                                :value="orgao.ID">
                                {{ orgao.SIGLA }} - {{ orgao.DESCRICAO }}
                            </b-form-select-option>
                        </b-form-select>
                    </b-col>

                    <b-col sm="5">
                        <label for="descricao">Motivo da Restrição <span class="text-danger">*</span></label>
                        <b-form-input 
                            id="descricao" 
                            v-model="novoFormulario.descricao" 
                            placeholder="Descreva a restrição"
                            required>
                        </b-form-input>
                    </b-col>
                </b-row>

                <b-row class="mt-3">
                    <b-col class="text-right">
                        <b-button 
                            variant="primary" 
                            type="submit"
                            :disabled="!formularioValido">
                            Incluir Restrição
                        </b-button>
                    </b-col>
                </b-row>
            </form>
        </b-card>

        <h2 class="title mt-4">Restrições de Tributos</h2>

        <b-card class="mb-4">
            <div class="d-flex justify-content-end align-items-center mb-2">
                Exibir
                <select v-model="perPage"
                    style="margin: 3px; width: 70px;">
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="15">15</option>
                </select>
                Linhas
            </div>
            <b-table 
                id="tabela-restricoes" 
                striped 
                hover 
                :items="listaRestricoesExibicao"
                :fields="colunasTabela"
                show-empty 
                empty-text="Nenhuma restrição encontrada."
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                :sort-compare="sortCompare"
                :current-page="currentPage"
                :per-page="perPage"
            >
                <template #cell(acoes)="data">
                    <b-button 
                        variant="outline-danger" 
                        size="sm" 
                        v-b-tooltip.hover title="Remover Restrição"
                        @click="removerRestricao(data.item)">
                        <b-icon icon="trash"></b-icon>
                    </b-button>
                </template>
            </b-table>
            <b-pagination
                v-model="currentPage"
                :total-rows="totalLinhas"
                :per-page="perPage"
                aria-controls="tabela-restricoes"
                align="right"
            ></b-pagination>
        </b-card>
    </div>
</template>

<script>
import { mask } from "vue-the-mask";    
import loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import normalizaMensagemApi from "../helpers/normalizaMensagemApi";
import mensagemAlerta from "../components/mensagemAlerta.vue";

export default {
    name: 'USC.21.021',
    components: {
        loading,
        mensagemAlerta,
    },
    directives: {
        mask,
    },
    data() {
        return {
            carregando: false,
            mensagemSucesso: [],
            mensagemErro: [],
            restricoesTributos: [],
            tributos: [],
            orgaosCobranca: [],
            novoFormulario: {
                codigoTributo: "",
                idOrgaoCobranca: "",
                descricao: ""
            },
            
            // Variáveis de ordenação
            sortBy: "DATA_INCLUSAO", 
            sortDesc: true, 
            sortDirection: "desc", 
            colunasTabela: [
                { key: 'tributoLabel', label: 'Tributo', sortable: true },
                { key: 'orgaoLabel', label: 'Órgão de Cobrança', sortable: true },
                { key: 'DATA_INCLUSAO', label: 'Data de Inclusão', sortable: true },
                { key: 'DESCRICAO', label: 'Motivo' },
                { key: 'acoes', label: 'Ações', class: 'text-center', thStyle: { width: '100px' } }
            ],

            // Variáveis de paginação
            currentPage: 1,
            perPage: 10, // Define quantos itens aparecem por página
        };
    },
    computed: {
        listaRestricoesExibicao() {
            return this.restricoesTributos
                .filter(r => !r.DATA_EXCLUSAO)
                .map(restricao => {
                    const tributo = this.tributos.find(t => t.ID_TRIBUTO === restricao.ID_TRIBUTO);
                    const orgao = this.orgaosCobranca.find(o => o.ID === restricao.ID_ORGAO_COBRANCA);
                    
                    return {
                        ...restricao,
                        tributoLabel: tributo ? `${tributo.CODIGO} - ${tributo.DESCRICAO_ABREVIADA}` : 'Tributo não encontrado',
                        orgaoLabel: orgao ? orgao.SIGLA : 'Órgão não encontrado',
                        DATA_INCLUSAO: this.formatarData(restricao.DATA_INCLUSAO),
                        
                        _codigoTributo: tributo ? parseInt(tributo.CODIGO) : 0,
                        _dataAdicao: new Date(restricao.DATA_INCLUSAO).getTime() 
                    };
                });
        },
        formularioValido() {
            return this.novoFormulario.codigoTributo && 
                   this.novoFormulario.idOrgaoCobranca && 
                   this.novoFormulario.descricao;
        },
        totalLinhas() {
            return this.listaRestricoesExibicao.length;
        }
    },
    async beforeCreate() {
        const logado =
            this.$store.getters.userInfo.origem === "GovBr" ||
            this.$store.getters.userInfo.origem === "AD";
        if (!logado) this.$router.push({ name: "Home" });
    },
    async beforeMount() {
        this.buscarRestricaoTributos();
    },
    methods: {
        async buscarRestricaoTributos() {
            try {
                this.carregando = true;
                // this.limparMensagens();
                const response = await this.$axios.get(`${this.$env.url_backend}/v1/manutencao/retorna-restricoes`);
                
                this.restricoesTributos = response.data.restricoes || [];
                this.tributos = response.data.tributos || [];
                this.orgaosCobranca = response.data.orgaoCobranca || [];
                
                // Reseta para a primeira página ao buscar novos dados
                this.currentPage = 1;
                window.scrollTo(0, 0);

            } catch (error) {
                const mensagem = normalizaMensagemApi(error);
                this.mensagemErro.push(mensagem);
            } finally {
                this.carregando = false;
            }
        },
        async incluirRestricao() {
            try {
                this.carregando = true;
                this.limparMensagens();

                const tributoSelecionado = this.tributos.find(
                    t => t.CODIGO == this.novoFormulario.codigoTributo
                );

                if (!tributoSelecionado) {
                    this.mensagemErro.push("Código de tributo inválido ou não encontrado.");
                    return;
                }

                const payload = {
                    descricao: this.novoFormulario.descricao,
                    idTributo: tributoSelecionado.ID_TRIBUTO,
                    idOrgaoCobranca: this.novoFormulario.idOrgaoCobranca,
                };

                await this.$axios.post(`${this.$env.url_backend}/v1/manutencao/criar-restricao`, payload);
                
                this.mensagemSucesso.push("Restrição criada com sucesso.");

                this.limparFormulario();          
                await this.buscarRestricaoTributos();

            } catch (error) {
                const mensagem = normalizaMensagemApi(error);
                this.mensagemErro.push(mensagem);
            } finally {
                this.carregando = false;
            }
        },
        async removerRestricao(item) {
            try {
                const confirmar = confirm(`Tem certeza que deseja remover a restrição para o tributo ${item.tributoLabel}?`);
                if (!confirmar) return;

                this.carregando = true;
                this.limparMensagens();

                const payload = {
                    id: item.ID_RESTRICAO_ACESSO_DRAM,
                };

                await this.$axios.put(`${this.$env.url_backend}/v1/manutencao/desabilitar-restricao`, payload);

                this.mensagemSucesso.push("Restrição desabilitada com sucesso.");
                await this.buscarRestricaoTributos();

                
            } catch (error) {
                const mensagem = normalizaMensagemApi(error);
                this.mensagemErro.push(mensagem);
            } finally {
                this.carregando = false;
            }
        },
        
        sortCompare(a, b, key) {
            if (key === 'tributoLabel') {
                return a._codigoTributo - b._codigoTributo;
            }
            if (key === 'DATA_INCLUSAO') {
                return a._dataAdicao - b._dataAdicao;
            }
            if (key === 'orgaoLabel') {
                return a.orgaoLabel.localeCompare(b.orgaoLabel);
            }
            return false;
        },

        formatarData(valorDataString) {
            if (!valorDataString) return "-";
            const data = new Date(valorDataString);
            return data.toLocaleString("pt-BR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit"
            });
        },
        gotoElementById(id) {
            this.$nextTick(() => {
                const el = document.getElementById(id);
                if (el) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            });
        },
        limparMensagens() {
            this.mensagemSucesso = [];
            this.mensagemErro = [];
        },
        limparFormulario() {
            this.novoFormulario = {
                codigoTributo: "",
                idOrgaoCobranca: "",
                descricao: ""
            };
        }
    },
}
</script>